import { AxisData, AxisDataIn } from './types';

export const axisData = (dataIn: AxisDataIn): AxisData => {
	if (!dataIn) {
		return {
			x: 0,
			y: 0,
			z: 0
		};
	}

	return { x: null, y: null, z: null, ...dataIn };
};
